import * as lastStateActions from '../lastState/actions';
import * as sortingActions from './actions';
import { takeLatest } from '../../listenerMiddleware';

export const sortingListeners = () => {
  watchLastState();
};

function watchLastState() {
  takeLatest(sortingActions.sortingChanged, (action, { dispatch }) => {
    dispatch(lastStateActions.saveRequested());
  });
}
